import { render, staticRenderFns } from "./GlobalFAB.vue?vue&type=template&id=3bc89c6c"
import script from "./GlobalFAB.vue?vue&type=script&lang=js"
export * from "./GlobalFAB.vue?vue&type=script&lang=js"
import style0 from "./GlobalFAB.vue?vue&type=style&index=0&id=3bc89c6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports